import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Message icon
 *
 * @category Product
 */
const Message = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M7.534 6.644c2.426-2.426 6.097-3.902 9.543-3.73 3.444.17 6.476 1.683 8.73 4.084a12.4 12.4 0 0 1 1.774 2.426v.001c2.163 3.926 2.003 9.017-.4 12.794-2.33 3.66-6.708 5.91-11.038 5.714l-.419-.026c-1.053-.086-2.112-.305-3.146-.455-1.04-.15-2.066-.23-3.083-.047-.964.174-1.874.58-2.806.956-.927.373-1.873.715-2.886.738h-.002c-.163 0-.376.002-.551-.106l-.011-.005-.008-.01-.005-.002-.03-.023v.002a.72.72 0 0 1-.265-.438 1.8 1.8 0 0 1-.024-.502v-.002l.046-.362c.133-.841.438-1.64.753-2.427.362-.903.737-1.79.905-2.725l.06-.417c.108-.976.008-1.96-.144-2.954-.152-.99-.357-1.998-.452-3.007l-.033-.432c-.195-3.333 1.145-6.699 3.492-9.045m8.834-2.157c-3.199 0-6.382 1.25-8.551 3.825-1.934 2.294-2.857 5.422-2.464 8.402.113.86.327 1.71.491 2.577.164.863.277 1.735.18 2.613-.105.893-.422 1.74-.733 2.572-.313.836-.62 1.66-.721 2.525a1 1 0 0 0 0 .285q.02.128.098.192.1.073.26.045c.106-.019.22-.068.325-.122l.003-.001c1.6-.778 2.716-1.52 4.537-1.566h.441c1.047.02 2.206.195 3.355.36 1.317.189 2.62.366 3.75.298 3.869-.236 7.538-2.678 9.236-6.165s1.372-7.887-.821-11.08c-2.159-3.137-5.759-4.748-9.375-4.76z"
        />
      </svg>
    );
  }
);

Message.displayName = 'Message';

export { Message };
